import { Instance, types } from 'mobx-state-tree';

export const ContentModel = types.model('ContentModel', {
  _id: types.identifier,
  type: types.string,
  title: types.maybeNull(types.string),
  humanReadableId: types.maybeNull(types.string),
  shortDescription: types.maybeNull(types.string),
  longDescription: types.maybeNull(types.string),
  summary: types.maybeNull(types.string),
  transcript: types.maybeNull(types.string),
  transcriptVisible: types.maybeNull(types.boolean),
  fileContent: types.maybeNull(types.string),
  estimatedTime: types.maybeNull(types.string),
  image: types.maybeNull(types.string),
  language: types.maybeNull(types.string),
  withTranscript: types.boolean,
  designSystemColor:types.maybeNull(types.string),
  activityType: types.maybeNull(types.string),

});

export type IContentModel = Instance<typeof ContentModel>;
